import { debounce, injectScriptOnce } from "../functions.js";

export default function TerrainAnimationModule(element) {

    let renderer;

    function initAnim() {
        if (!window.THREE || !window.THREEx) {
            setTimeout(() => {
                initAnim();
            }, 1000);
            return;
        }

        renderer	= new THREE.WebGLRenderer({ antialias: true, alpha: true });

        renderer.setSize(element.clientWidth, element.clientHeight);

        element.appendChild(renderer.domElement);
        
        var onRenderFcts = [];
        var scene	= new THREE.Scene();
        var camera	= new THREE.PerspectiveCamera(25, window.innerWidth / window.innerHeight, 0.01, 1000);
        /* Play around with camera positioning */
        camera.position.z = 15; 
        camera.position.y = 2;
        /* Fog provides depth to the landscape*/
        scene.fog = new THREE.Fog(0x000, 0, 45);
        // scene.background = new THREE.Color(0xff0000);

        ;(function(){
            var light	= new THREE.AmbientLight( 0x202020 )
            scene.add( light )
            var light	= new THREE.DirectionalLight('white', 5)
            light.position.set(0.5, 0.0, 2)
            scene.add( light )
            var light	= new THREE.DirectionalLight('white', 0.75*2)
            light.position.set(-0.5, -0.5, -2)
            scene.add(light);
        })()
        
        var heightMap	= THREEx.Terrain.allocateHeightMap(256,256)
        THREEx.Terrain.simplexHeightMap(heightMap)	
        var geometry	= THREEx.Terrain.heightMapToPlaneGeometry(heightMap)

        THREEx.Terrain.heightMapToVertexColor(heightMap, geometry)
        /* Wireframe built-in color is white, no need to change that */
        var material	= new THREE.MeshBasicMaterial({
            wireframe: true,
            color: getMaterialColor(),
        });

        var mesh	= new THREE.Mesh(geometry, material);
        scene.add( mesh );
        mesh.lookAt(new THREE.Vector3(0,1,0));
        /* Play around with the scaling */
        mesh.scale.y	= 3.5;
        mesh.scale.x	= 3;
        mesh.scale.z	= 0.20;
        
        mesh.scale.multiplyScalar(10);
        /* Play around with the camera */
        onRenderFcts.push(function(delta, now){
            mesh.rotation.z += 0.2 * delta;	
        })
        onRenderFcts.push(function(){
            renderer.render( scene, camera );		
        })
        var lastTimeMsec = null;
        let speed = 3000;
        requestAnimationFrame(function animate(nowMsec){
            requestAnimationFrame(animate);
            lastTimeMsec	= lastTimeMsec || nowMsec - 1000 / 60
            var deltaMsec	= Math.min(200, nowMsec - lastTimeMsec)
            lastTimeMsec	= nowMsec
            onRenderFcts.forEach(function(onRenderFct){
                onRenderFct(deltaMsec/speed, nowMsec/speed)
            })
        })
        element.style.opacity = 0.3;
    }

    function getMaterialColor() {
        let color = element.getAttribute('data-material-color');

        if (color) {
            return new THREE.Color(color);
        }

        return new THREE.Color(0xffffff);
    }

    window.addEventListener('resize', debounce(function() {
        
        if (renderer) {
            renderer.setSize(element.clientWidth, element.clientHeight);
        }

    }, 100));

    this.destroy = function() {
        
        element.style.opacity = 0;

        let canvas = element.querySelector('canvas');

        setTimeout(() => {
            element.removeChild(canvas);
        }, 600);
    }

    let initWithoutScrollTrigger = element.getAttribute('data-init-without-scrolltrigger');

    if (initWithoutScrollTrigger) {
        TerrainAnimationModule.loadScripts(function() { initAnim(); });
    } else {
        ScrollTrigger.create({
            trigger: element,
            once: true,
            start: 'top bottom',
            onEnter: self => {
                TerrainAnimationModule.loadScripts(function() { initAnim(); });
            }
        });

        if (ScrollTrigger.isInViewport(element, 0.2)) {
            TerrainAnimationModule.loadScripts(function() { initAnim(); });
        }
    }

    return this;
}

TerrainAnimationModule.loaded = false;
TerrainAnimationModule.loadScripts = function(callback) {
    if (TerrainAnimationModule.loaded) {
        callback && callback();
        return;
    }
    TerrainAnimationModule.loaded = true;
    
    injectScriptOnce(window.THEME_URL + '/js/SimplexNoise.js').then(() => {
        injectScriptOnce(window.THEME_URL + '/js/threex.terrain.js').then(() => {
            callback && callback();
        })
    });
}

window.addEventListener('load', function() {
    TerrainAnimationModule.loadScripts();
});